import React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Wordmark } from "@/components/common/Wordmark";
import { SidebarBody } from "@/components/shell/SidebarBody";
import { CircleDot } from "lucide-react";

export function MobileSidebar({ open, onOpenChange }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="left"
        className="w-[284px] p-0 flex flex-col"
        data-testid="mobile-sidebar"
        style={{ background: "linear-gradient(180deg, var(--chrome) 0%, var(--chrome-2) 100%)", borderColor: "var(--chrome-border)" }}
      >
        <SheetHeader className="sr-only">
          <SheetTitle>Navigation</SheetTitle>
          <SheetDescription>ddams dI primary navigation</SheetDescription>
        </SheetHeader>
        <div className="flex h-14 items-center border-b px-4" style={{ borderColor: "var(--chrome-border)" }}>
          <Wordmark />
        </div>
        <SidebarBody onNavigate={() => onOpenChange?.(false)} />
        <div className="border-t px-3 py-3" style={{ borderColor: "var(--chrome-border)" }}>
          <div
            className="flex items-center gap-2 rounded-lg border px-3 py-2 text-[11px] text-[color:var(--chrome-text-muted)]"
            style={{ borderColor: "var(--chrome-border)", backgroundColor: "var(--chrome-hover)" }}
          >
            <CircleDot className="h-3 w-3 text-[color:var(--accent-cyan)]" />
            <span>Ingestion endpoint <span className="font-mono text-[color:var(--chrome-text)]">active</span></span>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
